import React, { lazy, Suspense } from 'react';
const TheIcon = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'./TheIcon'));

const Icon = (props) => {
    return <Suspense fallback={null}>
        <TheIcon {...props} />
    </Suspense>
}

export default Icon;
